import components from './_components';
import methods from './_methods';
import validations from './_validations';
import FormWatcher from '@/inheritance/form-watcher';

// Mixins
import DatePickerMixin from '@/mixins/datepicker';
import DispatchersMixin from '@/mixins/dispatchers';
import LogoutMixin from '@/mixins/logout';

const defaultFormValues = {
    _links: {},
    asignee: null,
    blocking: null,
    category: null,
    description: '',
    expires_on: null,
    object: null,
    subject: ''
};

const defaultBlockingValues = [
    {
        name: 'Bloqueante',
        value: true
    },
    {
        name: 'No bloqueante',
        value: false
    }
];

export default {
    name: 'CreateEditIssue',
    validations,
    extends: FormWatcher,
    mixins: [DatePickerMixin, DispatchersMixin, LogoutMixin],
    components,
    methods,
    data() {
        return {
            asigneeType: [],
            blocking: defaultBlockingValues,
            categories: [],
            formValues: defaultFormValues,
            keyUpdate: 0,
            loading: false,
            objectType: [],
            saving: false,
            savingTitle: 'Guardar cambios',
            submitted: false,
            datepickerExpiresOn: ''
        };
    },

    watch: {
        formValues: {
            handler() {
                this.keyUpdate++;
            },
            deep: true
        },
        $route: {
            handler() {
                this.restoreValues();
                const { name } = this.$route;
                if (!name.includes('issues_add')) {
                    this.fetchData();
                } else if (name === 'issues_add_view') {
                    this.generateIssue();
                }
            },
            immediate: true
        },
        datepickerExpiresOn(val) {
            this.setExpirationDate(val);
        }
    },

    async beforeMount() {
        this.loading = true;
        this.restoreValues();
        if (this.$route.name.includes('issues_add')) {
            const res = await this.$issuesService.categories({});
            const { categories } = res.data;
            this.categories = categories;
            this.loading = false;
        }
    },

    computed: {
        /**
         * Indica si estamos editando un issue o no
         * @return {Boolean} Editable true/false
         */
        editable() {
            if (this.actionObject('ISSUES', 'edit')) {
                return this.$route.query.edit || this.$route.name.includes('issues_add') ? true : false;
            }
            return false;
        },
        isNewIssue() {
            if (this.actionObject('ISSUES', 'edit')) {
                return this.$route.name.includes('issues_add') ? true : false;
            }
            return false;
        }
    }
};
